import type { ConfigType } from '@plone/registry';
import installSettings from './config/settings';
import HTMLView from './components/HTMLView';

function applyConfig(config: ConfigType) {
  installSettings(config);
  config.blocks.blocksConfig.html = {
    ...config.blocks.blocksConfig.html,
    view: HTMLView,
  };
  return config;
}

export default applyConfig;
